/* eslint-disable no-undef */

export const clientId = process.env.https://radar_upload_frontend;
export const authAPI = process.env.https://radar-base-dev01.gsttdms.co.uk/managementportal/oauth;
export const authCallback = process.env.radar-base-dev01.gsttdms.co.uk/upload/login;
export const baseURL = process.env.https://radar-base-dev01.gsttdms.co.uk/upload/api/;

export default {
  clientId,
  authAPI,
  authCallback,
  baseURL,
};
